<template>
    <v-dialog v-if="showLoginModal" v-model="showLoginModal" width="350" :persistent="persistent">
        <login-form
            @authenticated="showLoginModal = false"
            @close="showLoginModal = false"
            @persist-form="persistent = true"
            :third-party-login-buttons-icons-only="true"
        />
    </v-dialog>
</template>

<script>
    import LoginForm from './LoginForm';
    import {mapMutations, mapState} from 'vuex';

    const moduleName = 'Login';

    export default {
        name: 'LoginModal',
        components: {
            LoginForm,
        },
        data() {
            return {
                persistent: false,
            }
        },
        beforeDestroy() {
            this.persistent = false;
        },
        computed: {
            ...mapState(moduleName, {
                showLoginModalState: state => state.showLoginModal,
            }),
            showLoginModal: {
                get(){
                    return this.showLoginModalState;
                },
                set(value){
                    if(!value){
                        this.errorMessage = null;
                        this.persistent = false;
                    }
                    return this.setShowLoginModal(value);
                },
            }
        },
        methods: {
            ...mapMutations(moduleName, [
                'setShowLoginModal',
            ]),
        },
    };
</script>